export default "__VITE_ASSET__Bv1LArl4__"